module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopLogin"
  }, [_c('div', {
    staticClass: "shopTop"
  }, [_c('div', {
    staticClass: "topLeft"
  }, [_c('div', {
    staticClass: "login",
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("亲，请登录")]), _vm._v(" "), _c('div', {
    staticClass: "register",
    on: {
      "click": _vm.goRegister
    }
  }, [_vm._v("免费注册")]), _vm._v(" "), _c('div', {
    staticClass: "home",
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('div', {
    staticClass: "topRight"
  }, [_c('div', {
    staticClass: "aboutUs",
    on: {
      "click": _vm.goAboutUs
    }
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('div', {
    staticClass: "contactUs",
    on: {
      "click": _vm.goContactUs
    }
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('div', {
    staticClass: "news",
    on: {
      "click": _vm.goNews
    }
  }, [_vm._v("资讯")]), _vm._v(" "), _c('div', {
    staticClass: "enter",
    on: {
      "click": _vm.goEnter
    }
  }, [_vm._v("商家入驻")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "5rem"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopGoods"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/shopLogin.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-362fde80","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/page/shopPC/shopLogin.vue
// module id = 3221
// module chunks = 1